import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import CustomerServiceNavigator from "../../../navigation/CustomerServiceNavigator";
import styles from "./customerService.module.css";

const CustomerService = () => {
  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/customer-support/show-users-chats">
              شات المستخدمين
            </PageLink>
          </div>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/customer-support/show-prize-Delivery">
              تسليم الجوائز
            </PageLink>
          </div>
        </div>
      </HorizantalBar>
      <CustomerServiceNavigator />
    </div>
  );
};

export default CustomerService;
